import { startCase } from 'lodash-es'
import { ONBOARDING_SECTIONS, OnboardingSectionId } from '../constants'
import { ProgressStyled } from '../onboardingStyles'

interface ISectionProgress {
  activeSection: OnboardingSectionId
}

const scrollToSection = (id: OnboardingSectionId) => {
  const target = document.getElementById(`section-${id}`)
  if (!target) return
  // `block: 'start'` together with the `scroll-margin-top` on SectionStyled lands the
  // heading just below the sticky top bar instead of being hidden behind it.
  target.scrollIntoView?.({ behavior: 'smooth', block: 'start' })
}

// Scroll indicator + jump nav: the section in the middle of the viewport is `active`
// (filled green rail, dark label) and the ones before it are `done`. Each step is a real
// button so the coach can click any label to jump to that section.
export const SectionProgress = ({ activeSection }: ISectionProgress) => {
  const activeIndex = ONBOARDING_SECTIONS.indexOf(activeSection)

  return (
    <ProgressStyled aria-label="Form sections">
      {ONBOARDING_SECTIONS.map((id, index) => {
        const className =
          index === activeIndex ? 'step active' : index < activeIndex ? 'step done' : 'step'
        return (
          <button
            type="button"
            className={className}
            key={id}
            onClick={() => scrollToSection(id)}
            aria-current={index === activeIndex ? 'step' : undefined}
          >
            <div className="rail" aria-hidden="true">
              <span />
            </div>
            {startCase(id)}
          </button>
        )
      })}
    </ProgressStyled>
  )
}
